import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["name", "onChange", "isRequired", "onBlur", "validator"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React, { useCallback, useContext, useEffect } from 'react';
import { FormValueContext, FormActionContext, FORM_ACTION_CHANGE, FORM_ACTION_TOUCH, FORM_ACTION_INIT } from './helper';
var withValidation = function withValidation(Component) {
  var component = Component.type.name;
  var FieldWithValidation = /*#__PURE__*/React.memo(function (_ref) {
    var name = _ref.name,
      onChange = _ref.onChange,
      isRequired = _ref.isRequired,
      onBlur = _ref.onBlur,
      validator = _ref.validator,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    var _useContext = useContext(FormValueContext),
      form = _useContext.form,
      fields = _useContext.fields;
    var isInitialized = form.isInitialized;
    var dispatch = useContext(FormActionContext);
    var type = rest && rest.hasOwnProperty('type') && typeof rest.type === 'string' ? rest.type : null;
    var update = useCallback(function (action, data) {
      if (data === void 0) {
        data = {};
      }
      dispatch({
        type: action,
        field: _objectSpread({
          name: name,
          isRequired: isRequired,
          validator: validator,
          type: type,
          component: component
        }, data)
      });
    }, [dispatch, name, isRequired, validator, type]);
    var onFieldBlur = useCallback(function (event) {
      update(FORM_ACTION_TOUCH);
      if (typeof onBlur === 'function') onBlur(event);
    }, [onBlur, update]);
    var onFieldChange = useCallback(function (value, event) {
      update(FORM_ACTION_CHANGE, {
        value: value
      });
      if (typeof onChange === 'function') onChange(value, event);
    }, [onChange, update]);
    var field = fields.hasOwnProperty(name) && typeof fields[name] === 'object' ? fields[name] : null;
    useEffect(function () {
      update(FORM_ACTION_INIT);
    }, [update]);
    if (isInitialized && (!field || !field.hasOwnProperty('isInitialized') || !field.isInitialized)) {
      return null;
    }
    var showError = field && field.isTouched && !field.isValid;
    var value = field ? field.value : undefined;
    return /*#__PURE__*/React.createElement(Component, Object.assign({
      name: name,
      value: value,
      onChange: onFieldChange,
      onBlur: onFieldBlur,
      isRequired: isRequired,
      hasError: showError
    }, rest));
  });
  FieldWithValidation.defaultProps = {
    isRequired: false
  };
  return FieldWithValidation;
};
export default withValidation;